<template>
  <div class="mentor_box">
    <div class="mentor_content_box" v-for="member in memberData" :key="`member${member.m_idx}`">
      <div class="mentor_content_box_img" :style="`background-image:url(${returnImage(member)})`" ></div>
      <div class="mentor_content_box_textBox">
        <div class="mentor_content_box_textBox_top">
          <div class="mentor_content_box_textBox_top_name">{{member.m_name}}</div>
          <div class="mentor_content_box_textBox_top_job">{{member.m_job}}</div>
        </div>
        <div class="mentor_content_box_textBox_bottom">
          <div class="mentor_content_box_textBox_text" v-html="decodeHtml(member.m_memo)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";

export default {
  name: "MemberListDefaultLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    memberData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(member) {
      if (!util.isEmpty(member.profile[0])) {
        return `${member.profile[0].org_url}?${this.setImageOptions(128, 128, 'jpg')}`;
      }
    },
    decodeHtml(html = '') {
      return util.htmlDecode(html);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>